export default {
  data() {
    return {
      statuses: [{
        key: 'new',
        name: 'Не обработан'
      }, {
        key: 'work',
        name: 'В работе'
      }, {
        key: 'counting',
        name: 'Выставлен счет'
      }, {
        key: 'completion',
        name: 'На выполнении'
      }, {
        key: 'done',
        name: 'Завершен'
      },],
    }
  },
  methods: {
    getStatusName(statusKey) {
      const status = this.statuses.find((s) => s.key === statusKey);
      return status ? status.name : 'Неизвестный статус';
    }
  }
}
